import { Field, renderRelatedFields, Select } from "components/shared/form";
import React from "react";
import { alert } from "services/alert";
import { DefaultTemplate } from "./templates";

export default class PrintModal extends DefaultTemplate {
    printBodyRef = React.createRef();

    componentDidMount() {
        this.setState({ isLoading: false });
        this.printWindow = window.open("", "PRINT", "height=400,width=700");
        if (!this.printWindow) {
            alert({
                type: "warning",
                title: "Печать недоступна",
                message: "Разрешите всплывающие окна для этого сайта и повторите печать.",
            });
            return;
        }

        this.printBodyObserver = new MutationObserver(this.schedulePrint);
        this.printBodyObserver.observe(this.printBodyRef.current, {
            childList: true,
            subtree: true,
            characterData: true,
        });
        this.schedulePrint();
    }

    componentWillUnmount() {
        clearTimeout(this.printTimeoutId);
        this.printBodyObserver?.disconnect();
        if (!this.printStarted && this.printWindow && !this.printWindow.closed) {
            this.printWindow.close();
        }
    }

    schedulePrint = () => {
        clearTimeout(this.printTimeoutId);
        this.printTimeoutId = setTimeout(this.print, 500);
    };

    print = () => {
        const printBody = this.printBodyRef.current;
        if (!printBody || !this.printWindow || this.printWindow.closed) {
            return;
        }

        this.printBodyObserver?.disconnect();
        const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .map((link) => link.outerHTML)
            .join("");

        this.printStarted = true;
        this.printWindow.document.write(`
            <html>
                <head>
                    <title>${document.title}</title>
                    ${stylesheets}
                </head>
                <body>
                    ${printBody.innerHTML}
                    <script type="text/javascript">
                        window.addEventListener("load", () => { window.print(); setTimeout(() => { window.close(); }, 0); })
                    </script>
                </body>
            </html>
        `);
        this.printWindow.document.close();
        this.printWindow.focus();
    };

    setValue = () => {
        return null;
    };

    renderField = (props) => {
        return (
            <Field
                key={props.label}
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.props.bodyData.values[props.inputProps.name]}
                {...props}
                inputProps={{ ...props.inputProps, disabled: "disabled" }}
            />
        );
    };

    renderSelect = (props) => {
        const defProps = {
            key: props.label,
            wrapper: "panel__row",
            onChange: this.setValue,
            value: this.props.bodyData.values[props.inputProps.name],
        };
        props.dictionary && (props.options = this.props.enums[props.dictionary] || []);
        props.inputProps.disabled = "disabled";
        if (props.relatedFields) {
            const fieldsData = { defProps, props, renderSelect: this.renderSelect, renderField: this.renderField };
            return renderRelatedFields(fieldsData);
        }
        const { key, ...selectProps } = { ...defProps, ...props };
        return <Select {...selectProps} key={key} />;
    };

    renderBody = () => {
        const { CustomBody, text, bodyData, trackersList } = this.props;
        if (CustomBody) {
            return (
                <div id="printBody" ref={this.printBodyRef}>
                    <CustomBody
                        renderField={this.renderField}
                        renderSelect={this.renderSelect}
                        {...bodyData}
                        trackersList={trackersList}
                    />
                </div>
            );
        }
        return (
            <div className="modal-window__body" id="printBody" ref={this.printBodyRef}>
                {text}
            </div>
        );
    };

    renderFooter = () => {
        return null;
    };
}
